import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Message } from '../../models/message';
import { Identificator } from '../../models/custom-types';
import { DocumentStatus } from '../../enums/document-status.enum';
import { TableResponse } from '../../models/table-response';

@Injectable()
export class PostApi {
  getMessageForReception(): Observable<TableResponse<Message>> {
    const messages: Message[] = [
      {
        id: 1 as Identificator,
        status: DocumentStatus.PRZY,
        sender: 'user1@example.com',
        sendingTime: new Date('2025-06-01T08:30:00Z'),
        confirmationTime: new Date('2025-06-01T08:31:00Z'),
        documentId: 1,
      },
      {
        id: 2 as Identificator,
        status: DocumentStatus.PRZY,
        sender: 'user2@example.com',
        sendingTime: new Date('2025-06-02T09:15:00Z'),
        confirmationTime: new Date('2025-06-02T09:16:00Z'),
        documentId: 2,
      },
      {
        id: 3 as Identificator,
        status: DocumentStatus.PRZY,
        sender: 'user3@example.com',
        sendingTime: new Date('2025-06-03T10:00:00Z'),
        confirmationTime: new Date('2025-06-03T10:01:30Z'),
        documentId: 3,
      },
      {
        id: 4 as Identificator,
        status: DocumentStatus.ODBR,
        sender: null,
        sendingTime: new Date('2025-06-04T11:45:00Z'),
        confirmationTime: new Date('2025-06-04T11:46:00Z'),
        documentId: 4,
      },
      {
        id: 5 as Identificator,
        status: DocumentStatus.ODBR,
        sender: 'user5@example.com',
        sendingTime: new Date('2025-06-05T12:20:00Z'),
        confirmationTime: new Date('2025-06-05T12:21:00Z'),
        documentId: 5,
      },
      {
        id: 6 as Identificator,
        status: DocumentStatus.ODBR,
        sender: 'user6@example.com',
        sendingTime: new Date('2025-06-06T13:10:00Z'),
        confirmationTime: new Date('2025-06-06T13:11:00Z'),
        documentId: 6,
      },
      {
        id: 7 as Identificator,
        status: DocumentStatus.ODBR,
        sender: 'user7@example.com',
        sendingTime: new Date('2025-06-07T14:05:00Z'),
        confirmationTime: new Date('2025-06-07T14:06:00Z'),
        documentId: 7,
      },
    ];

    const tableResponse: TableResponse<Message> = {
      content: messages,
      page: {
        size: messages.length,
        number: 0,
        totalElements: messages.length,
        totalPages: 1,
      },
    };

    return of(tableResponse);
  }
}
